import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Grid,
  Card,
  Avatar,
  AppBar,
  Toolbar,
  Menu,
  MenuItem as MenuItemComponent,
  Tabs,
  Tab,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Pagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Checkbox,
  FormControlLabel
} from '@mui/material';
import {
  NotificationsOutlined,
  Add,
  Close
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';
import { projectService } from '../services/projectService';
import { apiService } from '../services/api';
import Footer from '../components/Footer';
import ProjectDetailsPage from './ProjectDetailsPage';
import logo from '../assets/logo.png';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

const ProjectsPage = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeTab, setActiveTab] = useState(1); // Projects tab
  const [projects, setProjects] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);

  // Helper function to capitalize username
  const capitalizeUsername = (username) => {
    if (!username) return '';
    return username.charAt(0).toUpperCase() + username.slice(1).toLowerCase();
  };
  const [totalPages, setTotalPages] = useState(1);

  const [filters, setFilters] = useState({
    industryType: 'all'
  });
  const [openDialog, setOpenDialog] = useState(false);
  const [demoMode, setDemoMode] = useState(true); // Enable demo mode for development
  const [projectData, setProjectData] = useState({
    name: '',
    type: '',
    description: '',
    investment: '',
    industryType: '',
    services: [],
    aadharDocument: null,
    panDocument: null
  });
  const [userProfile, setUserProfile] = useState(null);
  const [showDocumentUpload, setShowDocumentUpload] = useState(false);
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [openProjectDetails, setOpenProjectDetails] = useState(false);
  const [availableServices, setAvailableServices] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    const userInfo = localStorage.getItem('userInfo');
    
    if (!token) {
      navigate('/login');
      return;
    }
    
    if (userInfo) {
      setUser(JSON.parse(userInfo));
    }

    // Load user's projects and profile from API
    if (userInfo) {
      loadUserProjects();
      loadUserProfile();
    }
  }, [navigate]);

  // Load projects when user changes
  useEffect(() => {
    if (user) {
      loadUserProjects();
      loadAvailableServices();
    }
  }, [user]);

  const loadAvailableServices = async () => {
    try {
      const response = await apiService.getActiveServices();
      const services = response.data || [];
      setAvailableServices(services);
    } catch (error) {
      console.error('Error loading services:', error);
      // Fallback to default services if API fails
      setAvailableServices([
        { id: 1, code: 'firm_registration', name: 'Firm Registration' },
        { id: 2, code: 'udyam_registration', name: 'Udyam Registration' },
        { id: 3, code: 'gst_registration', name: 'GST Registration' },
        { id: 4, code: 'others', name: 'Others' }
      ]);
    }
  };



  const loadUserProjects = async (page = 1) => {
    try {
      setLoading(true);
      const response = await projectService.getUserProjects(page);
      const data = response.results ? response : response.data || response;
      const projectsArray = data.results || data || [];
      console.log('User projects loaded:', projectsArray);
      setProjects(projectsArray);
      setFilteredProjects(projectsArray);

      setTotalPages(Math.ceil((data.count || projectsArray.length) / 10));
      setCurrentPage(page);
    } catch (error) {
      console.error('Error loading projects:', error);
      setProjects([]);
      setFilteredProjects([]);
    } finally {
      setLoading(false);
    }
  };

  const loadUserProfile = async () => {
    try {
      const response = await apiService.getUserProfile();
      setUserProfile(response.data);
    } catch (error) {
      console.error('Error loading user profile:', error);
    }
  };

  const handleLogout = async () => {
    try {
      await authService.logout();
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      navigate('/login');
    }
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    if (newValue === 0) navigate('/dashboard');
    if (newValue === 2) navigate('/messages');
    if (newValue === 3) navigate('/schemes');
  };

  const handleAddProject = () => {
    // Check if user has uploaded documents
    if (!userProfile || !userProfile.has_documents) {
      setShowDocumentUpload(true);
    } else {
      setOpenDialog(true);
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setProjectData({
      name: '',
      type: '',
      description: '',
      investment: '',
      industryType: '',
      services: [],
      aadharDocument: null,
      panDocument: null
    });
  };

  const handleDocumentUpload = async () => {
    try {
      if (!projectData.aadharDocument || !projectData.panDocument) {
        alert('Please upload both Aadhar and PAN documents');
        return;
      }

      const formData = new FormData();
      formData.append('aadhar_document', projectData.aadharDocument);
      formData.append('pan_document', projectData.panDocument);

      await apiService.uploadDocuments(formData);
      
      // Reload user profile to get updated document status
      await loadUserProfile();
      
      // Close document upload dialog and open project creation dialog
      setShowDocumentUpload(false);
      setProjectData({
        name: '',
        type: '',
        description: '',
        investment: '',
        industryType: '',
        services: [],
        aadharDocument: null,
        panDocument: null
      });
      setOpenDialog(true);
      
      alert('Documents uploaded successfully! You can now create your project.');
    } catch (error) {
      console.error('Error uploading documents:', error);
      alert('Failed to upload documents. Please try again.');
    }
  };

  const handleInputChange = (field) => (event) => {
    setProjectData(prev => ({
      ...prev,
      [field]: event.target.value
    }));
  };

  const handleFilterChange = (filterType) => (event) => {
    const newFilters = {
      ...filters,
      [filterType]: event.target.value
    };
    setFilters(newFilters);
  };

  const applyFilters = () => {
    let filtered = [...projects];
    
    if (filters.industryType !== 'all') {
      filtered = filtered.filter(project => project.industry_type === filters.industryType);
    }
    
    setFilteredProjects(filtered);
  };

  const handleSubmitProject = async () => {
    // Validate form
    if (!projectData.name || !projectData.type || !projectData.investment || !projectData.industryType) {
      alert('Please fill in all required fields');
      return;
    }

    if (projectData.services.length === 0) {
      alert('Please select at least one service');
      return;
    }

    try {
      setLoading(true);

      // DEMO MODE: Skip payment for development
      if (demoMode) {
        const formData = new FormData();
        formData.append('name', projectData.name);
        formData.append('project_type', projectData.type);
        formData.append('investment_amount', parseFloat(projectData.investment.replace(/,/g, '')));
        formData.append('industry_type', projectData.industryType.toLowerCase().replace(' ', '_'));
        formData.append('description', projectData.description);
        formData.append('services', JSON.stringify(projectData.services));
        formData.append('payment_id', 'DEMO_' + Date.now()); // Demo payment ID

        await projectService.createProject(formData);
        await loadUserProjects();
        
        alert('✅ Demo Mode: Project created successfully without payment!');
        handleCloseDialog();
        setLoading(false);
        return;
      }
      
      // Step 1: Initiate payment
      const token = localStorage.getItem('authToken');
      const paymentResponse = await axios.post(
        `${API_URL}/users/create-payment/`,
        {
          amount: 199, // ₹199 for project creation
          purpose: 'project_creation',
          project_name: projectData.name
        },
        { headers: { Authorization: `Token ${token}` } }
      );

      const { order_id, amount, currency } = paymentResponse.data;

      // Step 2: Open Razorpay payment modal
      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: amount,
        currency: currency,
        name: 'TICSPL',
        description: `Project Creation Fee - ${projectData.name}`,
        order_id: order_id,
        handler: async function (response) {
          try {
            // Step 3: Verify payment
            const verifyResponse = await axios.post(
              `${API_URL}/users/verify-payment/`,
              {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature
              },
              { headers: { Authorization: `Token ${token}` } }
            );

            if (verifyResponse.data.status === 'success') {
              // Step 4: Create project after successful payment
              const formData = new FormData();
              formData.append('name', projectData.name);
              formData.append('project_type', projectData.type);
              formData.append('investment_amount', parseFloat(projectData.investment.replace(/,/g, '')));
              formData.append('industry_type', projectData.industryType.toLowerCase().replace(' ', '_'));
              formData.append('description', projectData.description);
              formData.append('services', JSON.stringify(projectData.services));
              formData.append('payment_id', response.razorpay_payment_id);

              await projectService.createProject(formData);
              await loadUserProjects();
              
              alert('Payment successful! Project created successfully!');
              handleCloseDialog();
            }
          } catch (error) {
            console.error('Error verifying payment:', error);
            alert('Payment verification failed. Please contact support.');
          } finally {
            setLoading(false);
          }
        },
        prefill: {
          name: user?.username || '',
          email: user?.email || '',
          contact: user?.phone || ''
        },
        theme: {
          color: '#1976d2'
        },
        modal: {
          ondismiss: function() {
            setLoading(false);
            alert('Payment cancelled. Project not created.');
          }
        }
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();

    } catch (error) {
      console.error('Error creating project:', error);
      alert('Error initiating payment. Please try again.');
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'dpr_created': return '#2196f3';
      case 'under_review': return '#ff9800';
      case 'approved': return '#4caf50';
      case 'commissioned': return '#4caf50';
      case 'submitted': return '#666';
      default: return '#666';
    }
  };

  const getStatusBgColor = (status) => {
    switch (status) {
      case 'dpr_created': return '#e3f2fd';
      case 'under_review': return '#fff3e0';
      case 'approved': return '#e8f5e8';
      case 'commissioned': return '#e8f5e8';
      case 'submitted': return '#f5f5f5';
      default: return '#f5f5f5';
    }
  };

  // Helper function to capitalize each word
  const capitalizeWords = (str) => {
    if (!str) return 'N/A';
    return str
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  return (
    <Box sx={{ flexGrow: 1, bgcolor: '#f8f9fa', minHeight: '100vh', pb: 8 }}>
      {/* App Bar */}
      <AppBar position="static" sx={{ bgcolor: 'white', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
        <Toolbar sx={{ px: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mr: 4 }}>
            <img src={logo} alt="TICSPL" style={{ height: '32px', marginRight: '12px' }} />
            <Typography variant="h6" sx={{ color: '#1976d2', fontWeight: 600 }}>
              TICSPL
            </Typography>
          </Box>
          
          <Tabs 
            value={activeTab} 
            onChange={handleTabChange}
            sx={{ 
              flexGrow: 1,
              '& .MuiTab-root': {
                color: '#666',
                fontWeight: 500,
                textTransform: 'none',
                fontSize: '16px'
              },
              '& .Mui-selected': {
                color: '#1976d2 !important'
              }
            }}
          >
            <Tab label="Dashboard" />
            <Tab label="Projects" />
            <Tab label="Messages" />
            <Tab label="Schemes" />
          </Tabs>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <IconButton sx={{ color: '#666' }}>
              <NotificationsOutlined />
            </IconButton>
            <Button
              color="inherit"
              onClick={handleMenuOpen}
              sx={{ 
                color: '#333',
                textTransform: 'none',
                fontWeight: 500
              }}
              endIcon={<Avatar sx={{ width: 32, height: 32, bgcolor: '#1976d2' }}>{user?.username?.charAt(0).toUpperCase()}</Avatar>}
            >
              {capitalizeUsername(user?.username) || 'Priya'}
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >
              <MenuItemComponent onClick={handleMenuClose}>Profile</MenuItemComponent>
              <MenuItemComponent onClick={handleLogout}>Logout</MenuItemComponent>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>

      <Container maxWidth="xl" sx={{ py: 4 }}>
        {/* Header */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
          <Typography variant="h3" sx={{ fontWeight: 600, color: '#333' }}>
            Projects
          </Typography>
          <Button 
            variant="contained"
            startIcon={<Add />}
            sx={{ 
              bgcolor: '#ff9800',
              '&:hover': { bgcolor: '#f57c00' },
              px: 3,
              py: 1.5
            }}
            onClick={handleAddProject}
          >
            Add Project
          </Button>
        </Box>

        {/* Filters */}
        <Box sx={{ display: 'flex', gap: 2, mb: 4, alignItems: 'center' }}>
          <FormControl sx={{ minWidth: 200 }}>
            <InputLabel>Industry Type</InputLabel>
            <Select 
              label="Industry Type"
              value={filters.industryType}
              onChange={handleFilterChange('industryType')}
            >
              <MenuItem value="all">All Types</MenuItem>
              <MenuItem value="food_processing">Food Processing</MenuItem>
              <MenuItem value="textile">Textile</MenuItem>
              <MenuItem value="engineering">Engineering</MenuItem>
              <MenuItem value="electronics">Electronics</MenuItem>
              <MenuItem value="renewable_energy">Renewable Energy</MenuItem>
              <MenuItem value="manufacturing">Manufacturing</MenuItem>
              <MenuItem value="agriculture">Agriculture</MenuItem>
              <MenuItem value="healthcare">Healthcare</MenuItem>
            </Select>
          </FormControl>
          
          <Button 
            variant="contained"
            onClick={applyFilters}
            sx={{ 
              bgcolor: '#ff9800',
              '&:hover': { bgcolor: '#f57c00' },
              px: 3,
              py: 1.5
            }}
          >
            Apply Filters
          </Button>
        </Box>

        {/* Projects Grid */}
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
            <Typography>Loading projects...</Typography>
          </Box>
        ) : filteredProjects.length === 0 ? (
          <Box sx={{ textAlign: 'center', py: 8 }}>
            <Typography variant="h6" color="text.secondary" sx={{ mb: 2 }}>
              No projects found
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Create your first project to get started with TICSPL services.
            </Typography>
            <Button 
              variant="contained"
              startIcon={<Add />}
              onClick={handleAddProject}
              sx={{ 
                bgcolor: '#ff9800',
                '&:hover': { bgcolor: '#f57c00' }
              }}
            >
              Create Your First Project
            </Button>
          </Box>
        ) : (
          <Grid container spacing={3}>
            {filteredProjects.map((project) => (
              <Grid item xs={12} md={6} lg={4} key={project.id}>
                <Card 
                  sx={{ 
                    height: '100%',
                    cursor: 'pointer',
                    border: '1px solid #e0e0e0',
                    borderRadius: 2,
                    transition: 'all 0.3s ease',
                    '&:hover': { 
                      boxShadow: '0 8px 24px rgba(0,0,0,0.12)', 
                      transform: 'translateY(-4px)',
                      borderColor: '#1976d2'
                    }
                  }}
                  onClick={() => {
                    setSelectedProjectId(project.id);
                    setOpenProjectDetails(true);
                  }}
                >
                  {/* Header with Status */}
                  <Box sx={{ 
                    p: 2, 
                    pb: 1.5,
                    borderBottom: '1px solid #f0f0f0'
                  }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                      <Typography variant="h6" sx={{ fontWeight: 700, color: '#1a1a1a', flex: 1, pr: 2 }}>
                        {capitalizeWords(project.name)}
                      </Typography>
                      <Chip 
                        label={capitalizeWords(project.status_display || project.status)}
                        size="small"
                        sx={{ 
                          bgcolor: getStatusBgColor(project.status),
                          color: getStatusColor(project.status),
                          fontWeight: 600,
                          fontSize: '0.7rem',
                          height: '22px'
                        }}
                      />
                    </Box>
                    <Typography variant="body2" sx={{ color: '#666', fontSize: '0.875rem' }}>
                      {capitalizeWords(project.project_type)}
                    </Typography>
                  </Box>

                  {/* Investment Amount */}
                  <Box sx={{ p: 2, py: 2, bgcolor: '#f8f9fa' }}>
                    <Typography variant="caption" sx={{ 
                      color: '#666', 
                      fontWeight: 600,
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      display: 'block',
                      mb: 0.5,
                      fontSize: '0.7rem'
                    }}>
                      Total Investment
                    </Typography>
                    <Typography variant="h6" sx={{ fontWeight: 700, color: '#1976d2' }}>
                      {project.formatted_investment || `₹${project.investment_amount?.toLocaleString('en-IN') || '0'}`}
                    </Typography>
                  </Box>

                  {/* Consultant Info */}
                  <Box sx={{ p: 2 }}>
                    {project.consultant_name ? (
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Avatar sx={{ width: 36, height: 36, mr: 1.5, bgcolor: '#1976d2', fontWeight: 600, fontSize: '0.9rem' }}>
                          {project.consultant_name.charAt(0).toUpperCase()}
                        </Avatar>
                        <Box>
                          <Typography variant="body2" sx={{ fontWeight: 600, color: '#333', fontSize: '0.875rem' }}>
                            {capitalizeWords(project.consultant_name)}
                          </Typography>
                          <Typography variant="caption" sx={{ color: '#666', fontSize: '0.75rem' }}>
                            {capitalizeWords(project.consultant_designation) || 'Consultant'}
                          </Typography>
                        </Box>
                      </Box>
                    ) : (
                      <Box sx={{ 
                        display: 'flex', 
                        alignItems: 'center',
                        p: 1,
                        bgcolor: '#fff3e0',
                        borderRadius: 1
                      }}>
                        <Typography variant="caption" sx={{ color: '#f57c00', fontWeight: 500, fontSize: '0.75rem' }}>
                          ⚠️ No consultant assigned
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}

        {/* Pagination */}
        {totalPages > 1 && (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
            <Pagination 
              count={totalPages} 
              page={currentPage} 
              onChange={(event, page) => loadUserProjects(page)}
              color="primary" 
            />
          </Box>
        )}
      </Container>

      {/* Add Project Dialog */}
      <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          bgcolor: '#f8f9fa',
          borderBottom: '1px solid #e0e0e0'
        }}>
          <Typography variant="h6" sx={{ fontWeight: 600, color: '#333' }}>Create New Project</Typography>
          <IconButton onClick={handleCloseDialog} size="small">
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 3 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5, mt: 1 }}>
            {/* Basic Information */}
            <TextField
              fullWidth
              label="Project Name"
              value={projectData.name}
              onChange={handleInputChange('name')}
              required
              size="small"
            />
            
            <Box sx={{ display: 'flex', gap: 2 }}>
              <FormControl fullWidth required size="small">
                <InputLabel>Project Type</InputLabel>
                <Select
                  value={projectData.type}
                  onChange={handleInputChange('type')}
                  label="Project Type"
                >
                  <MenuItem value="Food Processing Unit">Food Processing Unit</MenuItem>
                  <MenuItem value="Garment Manufacturing Unit">Garment Manufacturing Unit</MenuItem>
                  <MenuItem value="Fabrication Plant">Fabrication Plant</MenuItem>
                  <MenuItem value="Solar Power Project">Solar Power Project</MenuItem>
                  <MenuItem value="Electronics Manufacturing">Electronics Manufacturing</MenuItem>
                </Select>
              </FormControl>
              
              <FormControl fullWidth required size="small">
                <InputLabel>Industry Type</InputLabel>
                <Select
                  value={projectData.industryType}
                  onChange={handleInputChange('industryType')}
                  label="Industry Type"
                >
                  <MenuItem value="Food Processing">Food Processing</MenuItem>
                  <MenuItem value="Textile">Textile</MenuItem>
                  <MenuItem value="Engineering">Engineering</MenuItem>
                  <MenuItem value="Electronics">Electronics</MenuItem>
                  <MenuItem value="Renewable Energy">Renewable Energy</MenuItem>
                  <MenuItem value="Manufacturing">Manufacturing</MenuItem>
                  <MenuItem value="Agriculture">Agriculture</MenuItem>
                  <MenuItem value="Healthcare">Healthcare</MenuItem>
                </Select>
              </FormControl>
            </Box>
            
            <TextField
              fullWidth
              label="Total Investment (in Rupees)"
              value={projectData.investment}
              onChange={handleInputChange('investment')}
              placeholder="e.g., 30,00,000"
              required
              size="small"
            />
            
            <TextField
              fullWidth
              label="Project Description"
              multiline
              rows={2}
              value={projectData.description}
              onChange={handleInputChange('description')}
              placeholder="Brief description of your project..."
              size="small"
            />
            
            {/* Services Selection */}
            <Box>
              <Typography variant="subtitle2" sx={{ mb: 1.5, fontWeight: 600, color: '#333' }}>Services Required</Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                {availableServices.length > 0 ? (
                  availableServices.map((service) => (
                    <FormControlLabel
                      key={service.id || service.code}
                      control={
                        <Checkbox
                          checked={projectData.services.includes(service.code)}
                          onChange={(e) => {
                            const newServices = e.target.checked
                              ? [...projectData.services, service.code]
                              : projectData.services.filter(s => s !== service.code);
                            setProjectData(prev => ({ ...prev, services: newServices }));
                          }}
                          size="small"
                          sx={{ color: '#1976d2' }}
                        />
                      }
                      label={service.name}
                      sx={{ 
                        '& .MuiFormControlLabel-label': { 
                          fontSize: '0.875rem',
                          color: '#333'
                        }
                      }}
                    />
                  ))
                ) : (
                  <Typography variant="body2" color="text.secondary">
                    Loading services...
                  </Typography>
                )}
              </Box>
            </Box>
            

            {/* Payment Info */}
            <Box sx={{ 
              mt: 3, 
              p: 2, 
              bgcolor: demoMode ? '#fff3e0' : '#e3f2fd', 
              borderRadius: 2,
              border: demoMode ? '1px solid #ffb74d' : '1px solid #90caf9'
            }}>
              {demoMode ? (
                <>
                  <Typography variant="body2" sx={{ fontWeight: 600, color: '#f57c00', mb: 0.5 }}>
                    🚀 Demo Mode Active
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#666' }}>
                    Payment is <strong>bypassed</strong> in demo mode. Projects will be created instantly without payment.
                  </Typography>
                  <Button
                    size="small"
                    onClick={() => setDemoMode(false)}
                    sx={{ mt: 1, textTransform: 'none', color: '#f57c00' }}
                  >
                    Enable Real Payment (₹199)
                  </Button>
                </>
              ) : (
                <>
                  <Typography variant="body2" sx={{ fontWeight: 600, color: '#1976d2', mb: 0.5 }}>
                    💳 Payment Required
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#666' }}>
                    A one-time fee of <strong>₹199</strong> is required to create your project. This covers initial consultation and document processing.
                  </Typography>
                  <Button
                    size="small"
                    onClick={() => setDemoMode(true)}
                    sx={{ mt: 1, textTransform: 'none', color: '#1976d2' }}
                  >
                    Use Demo Mode (Skip Payment)
                  </Button>
                </>
              )}
            </Box>

          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 3, bgcolor: '#f8f9fa', borderTop: '1px solid #e0e0e0', flexDirection: 'column', alignItems: 'stretch', gap: 1 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <Button onClick={handleCloseDialog} sx={{ color: '#666' }}>Cancel</Button>
          <Button 
            variant="contained" 
            onClick={handleSubmitProject}
            disabled={!projectData.name || !projectData.type || !projectData.investment || !projectData.industryType || projectData.services.length === 0 || loading}
            sx={{ 
              bgcolor: '#ff9800',
              '&:hover': { bgcolor: '#f57c00' },
              px: 3
            }}
          >
            {loading ? 'Processing...' : (demoMode ? '🚀 Create Project (Demo)' : 'Pay ₹199 & Create Project')}
          </Button>
          </Box>
        </DialogActions>
      </Dialog>

      {/* Document Upload Dialog */}
      <Dialog open={showDocumentUpload} onClose={() => setShowDocumentUpload(false)} maxWidth="md" fullWidth>
        <DialogTitle sx={{ bgcolor: '#f8f9fa', borderBottom: '1px solid #e0e0e0' }}>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>Upload Documents</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Please upload your Aadhar and PAN documents to create your first project. These documents will be used for all future projects.
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ p: 3 }}>
          <Box sx={{ display: 'flex', gap: 3, mt: 2 }}>
            <Box sx={{ 
              flex: 1,
              border: '2px dashed #ccc', 
              borderRadius: 2, 
              p: 3, 
              textAlign: 'center',
              bgcolor: '#fafafa'
            }}>
              <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600 }}>Aadhar Card *</Typography>
              <input
                type="file"
                accept=".pdf,.jpg,.jpeg,.png"
                onChange={(e) => setProjectData(prev => ({ ...prev, aadharDocument: e.target.files[0] }))}
                style={{ display: 'none' }}
                id="aadhar-upload-first"
              />
              <label htmlFor="aadhar-upload-first">
                <Button variant="outlined" component="span" sx={{ mb: 2 }}>
                  {projectData.aadharDocument ? 'Change File' : 'Choose File'}
                </Button>
              </label>
              {projectData.aadharDocument && (
                <Typography variant="body2" sx={{ color: '#4caf50', fontWeight: 500 }}>
                  {projectData.aadharDocument.name}
                </Typography>
              )}
            </Box>
            
            <Box sx={{ 
              flex: 1,
              border: '2px dashed #ccc', 
              borderRadius: 2, 
              p: 3, 
              textAlign: 'center',
              bgcolor: '#fafafa'
            }}>
              <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600 }}>PAN Card *</Typography>
              <input
                type="file"
                accept=".pdf,.jpg,.jpeg,.png"
                onChange={(e) => setProjectData(prev => ({ ...prev, panDocument: e.target.files[0] }))}
                style={{ display: 'none' }}
                id="pan-upload-first"
              />
              <label htmlFor="pan-upload-first">
                <Button variant="outlined" component="span" sx={{ mb: 2 }}>
                  {projectData.panDocument ? 'Change File' : 'Choose File'}
                </Button>
              </label>
              {projectData.panDocument && (
                <Typography variant="body2" sx={{ color: '#4caf50', fontWeight: 500 }}>
                  {projectData.panDocument.name}
                </Typography>
              )}
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 3, bgcolor: '#f8f9fa', borderTop: '1px solid #e0e0e0' }}>
          <Button onClick={() => setShowDocumentUpload(false)} sx={{ color: '#666' }}>Cancel</Button>
          <Button 
            variant="contained" 
            onClick={handleDocumentUpload}
            disabled={!projectData.aadharDocument || !projectData.panDocument}
            sx={{ 
              bgcolor: '#ff9800',
              '&:hover': { bgcolor: '#f57c00' },
              px: 3
            }}
          >
            Upload Documents
          </Button>
        </DialogActions>
      </Dialog>

      {/* Project Details Modal */}
      <ProjectDetailsPage 
        open={openProjectDetails}
        onClose={() => {
          setOpenProjectDetails(false);
          setSelectedProjectId(null);
          loadUserProjects(currentPage); // Reload projects to reflect any changes
        }}
        projectId={selectedProjectId}
      />

      {/* Fixed Footer */}
      <Footer />
    </Box>
  );
};

export default ProjectsPage;